import { LoadingScreen } from '@/components/shared/LoadingScreen';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { KPI } from '@/hooks/useCampaigns';
import { useReportPeriods } from '@/hooks/useReport';
import { formatKPI } from '@/utils/format';
import { format } from 'date-fns';
import { useNavigate, useParams } from 'react-router-dom';
import { BaseSettingsLayout } from './BaseSettingsLayout';

export const ReportsLayout = () => {
  const { id, kpi } = useParams();
  const navigate = useNavigate();
  const currentKPI = (kpi as KPI) || KPI.AWARENESS;
  const { data: reports, isLoading } = useReportPeriods();

  const sidebarNavItems =
    reports?.map((report) => ({
      title: format(new Date(report.period), 'MMMM yyyy'),
      href: `/reports/${report.id}/${currentKPI}`,
    })) ?? [];

  const handleKPIChange = (value: KPI) => {
    if (id) {
      navigate(`/reports/${id}/${value}`);
    }
  };

  if (isLoading) {
    return <LoadingScreen message="Reports loading..." />;
  }

  const headerContent = (
    <div className="flex items-center gap-4">
      <Select value={currentKPI} onValueChange={handleKPIChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Select KPI" />
        </SelectTrigger>
        <SelectContent>
          {Object.values(KPI).map((k) => (
            <SelectItem key={k} value={k}>
              {formatKPI(k)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button onClick={() => console.log('Generate Report')}>
        Generate Report
      </Button>
    </div>
  );

  return (
    <BaseSettingsLayout
      title="Reports"
      sidebarNavItems={sidebarNavItems}
      headerContent={headerContent}
    />
  );
};
